import { Component } from 'preact';
import { Profile } from './profile';

class Header extends Component {
	render(props, state) {
    let account = props.account

		return (
        <header id="header-container" className={props.sideMenuOpen? "side-menu-open" : "side-menu-closed"}>
          <button onClick={props.toggleMenu} className="veyobar-collapse-button"><i className={"fas fa-bars"}></i></button>
          <Profile account={account} profileMenuOpen={props.profileMenuOpen} toggleProfileMenu={props.toggleProfileMenu} logoutCallbackWrapper={props.logoutCallbackWrapper}></Profile>
        </header>
		);
	}
}

export {Header};



// WEBPACK FOOTER //
// ./components/header/header.js